module.exports = __webpack_public_path__ + "img/3.41781147.jpg";